import React, { useEffect, useState } from "react";
import CustomSelect from "../form/CustomSelect";
import "react-datepicker/dist/react-datepicker.css";
import SingleCalendarDateRangePicker from "../form/SingleCalendarDateRangePicker";
import {
    getStatuses,
    getTypes,
    plansResource,
    modelsTruckTrailerResource,
} from "../../helpers/configRoutes/backend_helper";
import CustomCalendarRange from "./CustomCalendarRange";

const FiltersPagination = ({
    meta,
    children,
    filters,
    setFilters,
    showFilters,
    statusModel,
}) => {
    const [showCalendar, setShowCalendar] = useState(false);
    const [statuses, setStatuses] = useState([]);
    const [plans, setPlans] = useState([]);
    const [types, setTypes] = useState([]);
    const [models, setModels] = useState([]);

    useEffect(() => {
        const getFilters = async () => {
            if (statusModel === "TrailerTruck") {
                const typesResponse = await getTypes("get", {
                    params: { select: true },
                });
                if (typesResponse?.types) setTypes(typesResponse.types);

                const modelsResponse = await modelsTruckTrailerResource("get", {
                    params: { select: true },
                });
                if (modelsResponse?.models) setModels(modelsResponse.models);
            } else {
                const plansResponse = await plansResource("get", {
                    params: { select: true },
                });
                if (plansResponse.status && plansResponse.plans) {
                    setPlans(plansResponse.plans);
                }
            }

            const statusesResponse = await getStatuses({
                params: { model: statusModel ?? "Subscription" },
            });
            if (statusesResponse.status && statusesResponse.statuses) {
                setStatuses(statusesResponse.statuses);
            }
        };

        if (showFilters) {
            getFilters();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showFilters, statusModel]);

    const resetFilters = () => {
        setFilters({
            ...filters,
            search: "",
            plan_id: "",
            status_id: "",
            startDate: "",
            endDate: "",
            model_id: "",
            type_id: "",
        });
    };

    const hasRange = filters.startDate && filters.endDate;

    return (
        <>
            {showFilters && (
                <div className="flex w-full mb-4 gap-4 items-start">
                    {/* Filtros */}
                    <div
                        className="
              flex items-center gap-3
              bg-cs-bg
              border border-cs-border
              rounded-2xl
              px-3 py-3
              w-2/3
              shadow-sm
            "
                    >
                        {/* Icono decorativo */}
                        <CustomCalendarRange
                            isClearable
                            holder="Date Range"
                            valueStart={filters.start_date}
                            valueEnd={filters.end_date}
                            filters={filters}
                            setFilters={setFilters}
                        />

                        {/* Plan / Type */}
                        <div className="flex items-center gap-2 pr-3 border-r border-cs-border/60">
                            {statusModel === "TrailerTruck" ? (
                                <CustomSelect
                                    className="border-none text-[11px]"
                                    options={types}
                                    holder="Type"
                                    value={filters.type_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            type_id: e.target.value,
                                        })
                                    }
                                />
                            ) : (
                                <>
                                    {statusModel !== "Settlement" && (
                                        <CustomSelect
                                            className="border-none text-[11px]"
                                            options={plans}
                                            holder="Subscription"
                                            value={filters.plan_id}
                                            onChange={(e) =>
                                                setFilters({
                                                    ...filters,
                                                    plan_id: e.target.value,
                                                })
                                            }
                                        />
                                    )}
                                </>
                            )}
                        </div>

                        {/* Status */}
                        <div className="flex items-center gap-2 pr-3 border-r border-cs-border/60">
                            <CustomSelect
                                className="border-none text-[11px]"
                                options={statuses}
                                holder="Status"
                                value={filters.status_id}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        status_id: e.target.value,
                                    })
                                }
                            />
                        </div>

                        {/* Reset */}
                        <button
                            type="button"
                            onClick={resetFilters}
                            className="
                flex items-center gap-1
                text-[10px]
                text-cs-danger
                hover:text-cs-danger
                hover:underline
                transition-colors
                ml-auto
              "
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                restart_alt
                            </span>
                            <span>Reset filters</span>
                        </button>
                    </div>

                    {/* Search */}
                    {statusModel !== "TrailerTruck" && (
                        <div className="w-1/3">
                            <div
                                className="
                  relative
                  bg-cs-bg
                  border border-cs-border
                  rounded-2xl
                  px-3 py-2
                  flex items-center gap-2
                  shadow-sm
                "
                            >
                                <span className="material-symbols-outlined text-[18px] text-cs-muted">
                                    search
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    value={filters.search}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            search: e.target.value,
                                        })
                                    }
                                    className="
                    w-full
                    bg-transparent
                    text-xs text-cs-dark
                    placeholder-cs-muted
                    focus:outline-none
                  "
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            {children}

            {/* Footer paginación */}
            <div className="flex items-center justify-between py-2 text-[11px]">
                {/* Texto resultados */}
                <div className="text-cs-muted">
                    Showing{" "}
                    <span className="font-semibold text-cs-dark">
                        {meta.from || 0}-{meta.to || 0}
                    </span>{" "}
                    of{" "}
                    <span className="font-semibold text-cs-dark">
                        {meta.total || 0}
                    </span>
                </div>

                {/* Controles */}
                <div className="flex items-center gap-1">
                    {/* Prev */}
                    <button
                        type="button"
                        disabled={filters.page === 1}
                        onClick={() =>
                            setFilters({
                                ...filters,
                                page: filters.page - 1,
                            })
                        }
                        className={`
              flex items-center justify-center w-8 h-8
              rounded-xl border border-cs-border
              text-cs-muted
              transition-colors
              ${filters.page === 1
                                ? "opacity-40 cursor-not-allowed"
                                : "hover:bg-cs-bg-alt hover:text-cs-dark"
                            }
            `}
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            chevron_left
                        </span>
                    </button>

                    {/* Next */}
                    <button
                        type="button"
                        disabled={meta.last_page === filters.page}
                        onClick={() =>
                            setFilters({
                                ...filters,
                                page: filters.page + 1,
                            })
                        }
                        className={`
              flex items-center justify-center w-8 h-8
              rounded-xl border border-cs-border
              text-cs-muted
              transition-colors
              ${meta.last_page === filters.page
                                ? "opacity-40 cursor-not-allowed"
                                : "hover:bg-cs-bg-alt hover:text-cs-dark"
                            }
            `}
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            chevron_right
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default FiltersPagination;
